import { render, staticRenderFns } from "./rankBox.vue?vue&type=template&id=6f9d3192&"
import script from "./rankBox.vue?vue&type=script&lang=js&"
export * from "./rankBox.vue?vue&type=script&lang=js&"
import style0 from "./rankBox.vue?vue&type=style&index=0&id=6f9d3192&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports